import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import carouselpic1 from "../../assets/home/carousel-pic1.jpg";
import carouselpic2 from "../../assets/home/carousel-pic2.jpg";
import carouselpic3 from "../../assets/home/carousel-pic3.jpg";


import "../Carousel.css";

function MainCarousel() {
  const responsive = {
    0: { items: 1.5 },
    650: { items: 1.5 },
    1024: {
      items: 2.5,
    },
  };


  const items = [
    <img src={carouselpic1}/>,
    <img src={carouselpic2}/>,
    <img src={carouselpic3}/>
  ];

  return (
    <>
      <section className="slider-contaniner">
        <AliceCarousel
          responsive={responsive}
          disableDotsControls={true}
          items={items}
        />
      </section>
    </>
  );
}

export default MainCarousel;
